import { CaretRightIcon } from '@panwds/icons';
import { Tooltip } from '@panwds/react-ui';
import { animated, useSpring, useTransition } from '@react-spring/web';
import React, { Fragment, useRef } from 'react';
import { metricsHelper } from '../../../utils/index.js';
import { useNavigationContextV3 } from '../NavigationContextV3/NavigationContextV3.js';
import { getNavItemCaretRightIconClass, getNavItemDotClasses, getNavItemIconClass, getNavItemIconWrapClasses, getNavItemListTooltipClasses, getNavItemTitleTextClasses, getNavListClasses, getTabButtonClass, getTitleWrapClasses, navItemV3Theme } from './navItemV3.logic.js';
// Maps dot colors to CSS class names
const appearanceClassName = navItemV3Theme.appearance;
const IconElement = ({ icon, match, iconClass }) => {
    const classes = getNavItemIconWrapClasses(match);
    return icon ? (React.createElement("div", { className: classes }, React.cloneElement(icon, { className: iconClass }))) : null;
};
export function SearchNavItem({ badge, dataMetrics, dataTestId, icon, id, className, disabled, dotColor, dotValue, title, url, hasChildren, isBottomNav }) {
    const { brandColorClass, collapsed, leftNavCollapsed, visitedNav, openSearchFlyout = false, setState } = useNavigationContextV3();
    const isVisiting = id === visitedNav;
    const flyOutRef = useRef(null);
    const match = openSearchFlyout;
    const normalizedId = metricsHelper(id);
    const titleTransition = useTransition(!leftNavCollapsed, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { duration: 250 }
    });
    const { width } = useSpring({
        width: leftNavCollapsed ? '48px' : '264px',
        config: { mass: 1, tension: 240, friction: 25 }
    });
    const onClickAction = () => {
        if (!collapsed) {
            setState((prev) => ({ ...prev, collapsed: false, leftNavCollapsed: false, subNavCollapsed: true }));
        }
        else {
            setState((prev) => ({
                ...prev,
                flyoutId: undefined,
                ...(prev.openSearchFlyout ? { flyOutRef: undefined } : { flyOutRef }),
                visitedNav: undefined,
                openSearchFlyout: !prev.openSearchFlyout
            }));
        }
    };
    const iconClass = getNavItemIconClass(match, brandColorClass, isVisiting, disabled);
    const classes = getTabButtonClass(disabled, match, isVisiting, isBottomNav, className?.button, leftNavCollapsed);
    const tabButton = (React.createElement(animated.button, { id: `navigation-${id}-btn`, "aria-expanded": match, "aria-controls": `navigation-item-${normalizedId}`, "data-metrics": dataMetrics || `navigation-${normalizedId}`, "data-testid": dataTestId || `navigation-${id}-btn`, "data-url": url, className: classes, style: { width }, ref: flyOutRef, onClick: onClickAction, ...(disabled ? { disabled: true } : {}) },
        dotColor &&
            leftNavCollapsed &&
            (!dotValue ? (React.createElement("div", { className: getNavItemDotClasses(dotValue, appearanceClassName[dotColor]) })) : (React.createElement("div", { className: getNavItemDotClasses(dotValue, appearanceClassName[dotColor]) }, dotValue > 10 ? '9+' : dotValue))),
        React.createElement(IconElement, { icon: icon, match: match, collapsed: leftNavCollapsed, iconClass: iconClass }),
        titleTransition((style, item) => item && (React.createElement(animated.div, { style: style, className: getTitleWrapClasses() },
            React.createElement("span", { className: getNavItemTitleTextClasses(match, disabled) }, title),
            badge && React.createElement("div", { className: "twds-z-20 twds-flex" }, badge)))),
        hasChildren && (React.createElement(CaretRightIcon, { className: getNavItemCaretRightIconClass(iconClass, match, leftNavCollapsed), size: 'xxs' }))));
    return (React.createElement(Fragment, null,
        React.createElement("li", { className: getNavListClasses(className?.root), "data-metrics": dataMetrics || `navigation-${metricsHelper(id)}`, "data-testid": dataTestId || `navigation-${id}` }, leftNavCollapsed && !openSearchFlyout ? (React.createElement(Tooltip, { defaultPlacement: "right", singleLine: true, label: title, delay: 100 },
            React.createElement("div", { className: getNavItemListTooltipClasses() }, tabButton))) : (React.createElement("div", { className: 'twds-mx-2' }, tabButton)))));
}
//# sourceMappingURL=SearchNavItem.js.map